import React, { useEffect } from 'react';

import { useInjectedEventAttribute } from '@atlassian/people-teams-ui/analytics';

import useAnalytics from './useAnalytics';

export default function ({ teamId }: { teamId?: string }) {
	const analytics = useAnalytics();

	useInjectedEventAttribute('teamId', teamId);

	useEffect(() => {
		analytics.setTeamId(teamId);
		() => {
			analytics.setTeamId(undefined);
		};
	}, [analytics, teamId]);

	return <></>;
}
